import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutation'
import actions from './actions'
import createPersistedState from 'vuex-persistedstate';
import quota from './modules/quota';
import appraise from './modules/appraise'

Vue.use(Vuex)

export default new Vuex.Store({
  state: state,
  mutations,
  actions,
  modules: {
    quota,
    appraise,
  },
  plugins: [createPersistedState({
    modules: ['quota']
  })]
})
